import React, { useEffect, useState } from 'react'
import GamePopup from '../../components/GamePopup'
import GameLoading from '../../components/GameLoading'

const Game = ({ appAssetsLoaded }) => {

    const [showOverlay, setShowOverlay] = useState(true);

    useEffect(() => {
        if (appAssetsLoaded) {
            const timeout = setTimeout(() => {
                setShowOverlay(false);
            }, 1500); // show loading for 2 more seconds

            return () => clearTimeout(timeout);
        }
    }, [appAssetsLoaded]);

    return (
        <div className='min-h-screen h-screen w-full'>
            {(showOverlay || !appAssetsLoaded) && (
                <div className="absolute top-0 left-0 w-full h-full z-50">
                    <GameLoading />
                </div>
            )}
            {appAssetsLoaded && <GamePopup />}
        </div>
    )
}

export default Game